import React from "react";
import { buildLogoStylesheet } from "./ElementLogoStyleResolver";
import BuilderStyleTag from "../shared/BuilderStyleTag";

const DEFAULT_CUSTOM_LOGO_URL =
  "https://uploads.convertflow.co/production/websites/417/xkLyrWoCSIWWDZQGlN9L_r7EfaBaSZWFE2F4WiA8w_brand-logo.png";
const DEFAULT_LIGHT_LOGO_URL =
  "https://uploads.convertflow.co/production/websites/417/Dage9SBxTSy85ePOKflw_brand-logo-white.png";

const ElementLogo = (props) => {
  const website = props.website;
  let element = props.element;
  let variant = props.variant;
  const stylesheet = buildLogoStylesheet(
    props.builder,
    props.device,
    props.cta,
    element
  );

  // Fallback hierarchy: element → variant → website
  const logoFormat = element.options["logo-format"] 
    ? element.options["logo-format"] 
    : variant.options["logo-format"]
      ? variant.options["logo-format"]
      : "image";
      
  const logoStyle = element.options["logo-style"] 
    ? element.options["logo-style"] 
    : variant.options["logo-style"]
      ? variant.options["logo-style"]
      : "dark";
      
  const logoSource =
    logoFormat == "image" && logoStyle == "custom"
      ? element.options["logo-image"] ||
        variant.options["logo-image"] ||
        DEFAULT_CUSTOM_LOGO_URL
      : logoFormat == "image" && website.data[`logo-${logoStyle}`]
        ? website.data[`logo-${logoStyle}`]
        : logoStyle == "dark"
          ? DEFAULT_CUSTOM_LOGO_URL
          : logoStyle == "light"
            ? DEFAULT_LIGHT_LOGO_URL
            : website.data["logo-dark"];
        
  const logoIconSource = logoFormat == "icon" && logoStyle == "custom" && element.options["logo-image"] 
    ? element.options["logo-image"] 
    : logoFormat == "icon" && logoStyle == "custom" && variant.options["logo-image"]
      ? variant.options["logo-image"]
      : website.data[`logo-icon-${logoStyle}`] 
        ? website.data[`logo-icon-${logoStyle}`] 
        : logoStyle == 'dark' 
          ? 'https://uploads.convertflow.co/production/websites/417/QI2ycrYmQIK5feEeq9J1_brand-logo-icon-dark.webp' 
          : logoStyle == 'light' 
            ? 'https://uploads.convertflow.co/production/websites/417/NESckLYPTVlOJGWTnzqs_brand-logo-icon-light.webp' 
            : website.data["logo-icon-dark"];

  const altText = element.options["alt-text"] 
    ? element.options["alt-text"] 
    : variant.options["logo-alt-text"]
      ? variant.options["logo-alt-text"]
      : "";

  const logoLink = element.options["logo-link"] ? element.options["logo-link"] : variant.options["logo-link"] ? variant.options["logo-link"] : website.data["logo-link"] ? website.data["logo-link"] : '#';
  const logoLinkNewTabValue = element.options["logo-link-new-tab"] ? element.options["logo-link-new-tab"] : variant.options["logo-link-new-tab"] ? variant.options["logo-link-new-tab"] : null;
  const logoLinkNewTab = ["true", "on"].includes(logoLinkNewTabValue);

  return (
    <React.Fragment>
      <div
        id={"element" + element.id + "-content"}
        className="element-content cf-text-element cf-logo"
      > 
        <a className="cf-logo-link" href={props.builder !== true ? logoLink : '#'} target={props.builder !== true && logoLink && logoLink !== '#' && logoLinkNewTab ? "_blank" : "_self"} disabled={props.builder === true} onClick={(e) => {
          if (props.builder == true) {
            e.preventDefault();
          }
        }}>
          {logoFormat == "image" && <img loading="lazy" data-format="image" data-style={logoStyle} src={logoSource} alt={altText} />}
          {logoFormat == "icon" && <img loading="lazy" data-format="icon" data-style={logoStyle} src={logoIconSource} alt={altText} />}
        </a>
      </div>
      <BuilderStyleTag
        builder={props.builder}
        styleKey={`cta:${props.cta.id}:element:${element.id}:logo`}
        stylesheet={stylesheet}
      />
    </React.Fragment>
  );
};

export default ElementLogo;
